<template>
  <div>
    <div id="wrapper">
      <template v-if="$route.query.headShow === '1'">
        <div class="header">
          <div class="header-left" @click="goBack"><img src="../../assets/vip/icon_back1.png" alt=""/></div>
          <div class="header-main">订单详情</div>
          <div class="header-right"></div>
        </div>
        <div class="header-pre"></div>
      </template>
      <!--banner区域 -->
      <div :class="['statusContent', bgName]">
        <div class="text">
          <div class="status">{{result.orderStatusName}}</div>
        </div>
      </div>
      <!-- 商品信息 -->
      <div class="goodsInfo">
        <h5 class="label">商品信息</h5>

        <van-skeleton title :row="4" :loading="loading">
          <section class="top">
            <div class="image"><img class="img" src="@/assets/vip/icon_gkbz.png"/></div>
            <div class="right-box">
              <div class="goods-name">{{result.goodsName}}</div>
              <div class="price">
                <div>{{result.orderAmount}}</div>
                <div>*{{result.amount}}</div>
              </div>
            </div>
          </section>
        </van-skeleton>

        <section class="bottom">
          <van-skeleton title :row="6" :loading="loading">
            <div class="row">
              <div class="label">支付方式</div>
              <div class="content">
                {{result.paymentType}}
              </div>
            </div>
            <div class="row">
              <div class="label">付款金额</div>
              <div class="content">
                <div><span style="color: #FF5050">{{result.orderAmount}}</span></div>
              </div>
            </div>
            <div class="row">
              <div class="label">订单编号</div>
              <div class="content">
                {{result.orderNo}}
              </div>
            </div>
            <div class="row">
              <div class="label">下单时间</div>
              <div class="content">
                {{result.orderTime}}
              </div>
            </div>
            <div class="row" v-if="result.payTime">
              <div class="label">支付时间</div>
              <div class="content">
                {{result.payTime}}
              </div>
            </div>
          </van-skeleton>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { Skeleton, Button, Icon, ActionSheet } from 'vant'

export default {
    components: {
        [Skeleton.name]: Skeleton,
        [Button.name]: Button,
        [Icon.name]: Icon,
        [ActionSheet.name]: ActionSheet
    },
    data () {
        return {
            loading: true,
            bgName: 'completed',
            imgUrl: '', // 商品信息里的左侧图片url
            status: '',
            result: {},
            id: ''
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$router.back()
        },
        getData () {
            this.loading = true
            this.$api.getEnsureDetails({ orderId: this.id }).then(res => {
                if (res.status) {
                    res.result.orderTime = res.result.orderTime ? this.moment.formatTime(res.result.orderTime, 'YYYY-MM-DD HH:mm:ss') : ''
                    this.result = res.result
                }
                this.loading = false
            })
        }
    },
    created () {
        this.id = this.$route.query.id
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
  * {
    word-break: break-all;
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    z-index: 9999;
    justify-content: space-between;
    height: 60px;
    background: #ffffff;

    .header-main {
      font: bold 18px PingFangSC;
      color: #333333;
    }

    .header-left, .header-right {
      display: flex;
      padding: 15px 10px;
      font-size: 0;
      line-height: 1;
      width: 24px;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .header-pre {
    height: 60px;
  }

  #wrapper {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    position: absolute;
    background: #fafafa;
  }

  .payment { // 待付款
    background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
  }

  .beshipped { // 待发货
    background: url('~@/assets/order/bg_to_be_shipped.png') no-repeat center;
  }

  .shipped { // 已发货
    background: url('~@/assets/order/bg_shipped.png') no-repeat center;
  }

  .completed { // 已完成
    background: url('~@/assets/order/bg_completed.png') no-repeat center;
  }

  .refund { // 退款中
    background: url('~@/assets/order/bg_refund.png') no-repeat center;
  }

  .cancelled { // 已取消
    background: url('~@/assets/order/bg_cancelled.png') no-repeat center;
  }

  .statusContent {
    height: 100px;
    background-size: 100%;
    position: relative;

    .text {
      position: absolute;
      top: 26px;
      left: 15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 45px;
    }

    .status {
      font: 600 24px PingFangSC-Semibold;
      color: rgba(51, 51, 51, 1);
    }

    .refundInfo {
      display: flex;
      align-items: center;
      padding-top: 10px;
      font: 400 14px PingFangSC-Regular;
      color: rgba(51, 51, 51, 1);
    }
  }

  .goodsInfo {
    background: white;
    padding: 20px 15px 0;

    .label {
      font: 400 14px PingFangSC-Regular;
      color: rgba(102, 102, 102, 1);
    }

    .top {
      display: flex;
      padding: 10px 0 6px;
      align-items: center;

      .image {
        width: 100px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        line-height: 1;
        font-size: 0;

        img {
          width: 100%;
        }
      }

      .right-box {
        margin-left: 15px;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;

        .goods-name {
          font: 400 15px PingFangSC-Regular;
          color: rgba(51, 51, 51, 1);
          word-wrap: break-word;
        }

        .other-name {
          display: flex;
          align-items: center;
          justify-content: center;
          width: fit-content;
          margin: 10px 0 0 0;
          padding: 0 5px;
          height: 20px;
          border-radius: 3px;
          border: 1px solid #666666;
          font: 400 14px PingFangSC-Regular, PingFang SC;
          color: #666666;
        }

        .price {
          display: flex;
          justify-content: space-between;
          padding-top: 10px;
          font-size: 14px;
          color: #666666;
        }
      }
    }
  }

  .row {
    &.hre {
      border-top: 1px solid #EEEEEE;
    }

    display: flex;
    justify-content: space-between;
    padding: 10px 0;

    .label {
      min-width: 100px;
      font: 400 14px PingFangSC-Regular;
      color: rgba(102, 102, 102, 1);
    }

    .content {
      &.red {
        color: #FF5050;
      }

      word-break: break-word;
      font: 400 14px PingFangSC-Regular;
      color: rgba(51, 51, 51, 1);
    }
  }

</style>
